import { LoaderFunction } from 'react-router';
import { Locale } from '@ivario-arc/shared/src/types/locales.ts';
import { oidcClient, userManager } from '@src/auth/oidcConfig';
import { Environment } from '@src/environment';
import { Paths } from '@src/routes/paths';
import { getStoredLanguage } from '@utils/language';

export default (async ({ request }) => {
  const user = await userManager.getUser();
  if ((user?.expires_in ?? 0) > 0) {
    return Response.redirect(Paths.PROFILE);
  } else {
    const url = new URL(request.url);
    const returnTo = url.searchParams.get('returnTo');
    const signinRequest = await oidcClient.createSigninRequest({
      request_type: 'si:r',
      redirect_uri: Environment.PUBLIC_URL + Paths.CALLBACK,
      state: returnTo ? { returnTo } : undefined,
      prompt: 'create',
      ui_locales: getStoredLanguage() ?? Locale.DE,
    });
    return Response.redirect(signinRequest.url);
  }
}) satisfies LoaderFunction;
